import additionalInfo from './es/additionalInfo';
import allDisputes from './es/allDisputes';
import button from './es/button';
import cancelDispute from './es/cancelDispute';
import caseStatusTags from './es/caseStatusTags';
import confirmationDisclaimer from './es/confirmationDisclaimer';
import contactFraud from './es/contactFraud';
import disputeInfo from './es/disputeInfo';
import eligibility from './es/eligibility';
import faqsAnswers from './es/faqsAnswers';
import faqsQuestions from './es/faqQuestions';
import formError from './es/formError';
import questionnaire from './es/questionnaire';
import sandbox from './es/sandbox';
import sorter from './es/sorter';
import uploadDocuments from './es/uploadDocuments';
import disputeDetails from './es/disputeDetails';
import transactionStatus from './es/transactionStatus';
import transactionDisputeStatusTitle from './es/transactionDisputeStatusTitle';
import transactionDisputeStatusDescription from './es/transactionDisputeStatusDescription';
var spanishTranslations = {
    translation: {
        additionalContent: {
            placeholder: 'Disputar Monto'
        },
        additionalInfo: additionalInfo,
        allDisputes: allDisputes,
        button: button,
        calendar: {
            afterError: 'Ingrese una fecha en o después de {{formattedStartDate}}',
            beforeError: 'Ingrese una fecha en o después de {{formattedStartDate}}',
            dateBeyond180Days: 'Por favor seleccione una fecha dentro de los últimos 180 días. Si la fecha supera ese período de tiempo, por favor use nuestro chat en línea para obtener ayuda para abrir un caso.',
            greaterThanSevenDays: 'Debe ser mayor a 7 días hábiles a partir de hoy',
            placeholder: 'Date (mm/dd/yyyy)',
            validDate: 'Ingrese una fecha válida.',
            waitSevenDays: 'Espere siete días hábiles antes de disputar esta transacción.'
        },
        cancelDispute: cancelDispute,
        cancelQuestionnaire: {
            description: 'Su progreso no será guardado.',
            title: 'El cierre cancelará la disputa. ¿Desea continuar?'
        },
        caseStatusTags: caseStatusTags,
        confirmation: {
            header: 'La disputa ha sido enviada satisfactoriamente',
            redisputeHeader: 'Tenemos documentados todos los detalles de su disputa original.',
            subHeader: 'La documentación nos puede enviarse a través de Gestionar disputas. Asegúrese de incluir cualquier detalle adicional que considere que ayudaría a resolver su disputa.',
            redisputeSubHeaderOne: 'A continuación, se enumeran los documentos de respaldo que usted entregó para la disputa original.',
            redisputeSubHeaderTwo: 'Tendrá la oportunidad de enviar cualquier documento o comentario adicional en un próximo paso.'
        },
        confirmationDisclaimer: confirmationDisclaimer,
        contactFraud: contactFraud,
        disputeDetails: disputeDetails,
        disputeInfo: disputeInfo,
        dropDown: {
            placeholder: 'Elija una Opción'
        },
        eligibility: eligibility,
        cantIdentify: {
            title: '--NEED SPANISH-- We couldn’t identify the duplicate transaction on your account',
            description: '--NEED SPANISH--  If you need more help, please contact us using <0>Online Chat.</0>'
        },
        exit: {
            closeOut: 'Haga clic en el botón de abajo o en la "X" para cerrar esta ventana.',
            description: 'No procederemos a abrir una disputa en este momento.',
            title: 'Gracias por tu tiempo'
        },
        faqs: {
            header: 'Preguntas Frecuentes',
            link: 'Preguntas Frecuentes sobre Disputas',
            modalTitle: 'Preguntas Frecuentes sobre Disputas'
        },
        faqsAnswers: faqsAnswers,
        faqsQuestions: faqsQuestions,
        formError: formError,
        greeting: {
            afternoon: 'Buenas Tardes',
            evening: 'Buenas Noches',
            morning: 'Buenos Días'
        },
        label: {
            cancelDisputeModal: 'Disputas de Synchrony Cancelar Disputa Modal',
            headerRow: 'Encabezado de Caso en Disputa',
            questionnaireModal: 'Disputas de Synchrony Cuestionario Modal'
        },
        lowBalanceDisputeCaseConfirmation: {
            contactUs: 'Si tiene alguna pregunta acerca de este crédito, comuníquese con nosotros a través de <0>chat en línea.</0>',
            description: 'Hemos resuelto su disputa y hemos emitido un crédito a su favor de {{disputeAmount}}. Todas las tarifas e intereses asociados con este cargo serán eximidos. Podrá ver el crédito en su cuenta dentro de las próximas 5 días hábiles y puede esperar ver el ajuste en su estado de cuenta dentro de 1 a 2 ciclos de facturación. También le enviaremos una carta. Si tiene alguna pregunta con respecto a este crédito, comuníquese con nosotros mediante el chat en directo.',
            title: '¡Buenas noticias!'
        },
        modal: {
            title: 'Disputas'
        },
        questionnaire: questionnaire,
        recognizeTransaction: {
            question: '¿Reconoce el cargo?',
            recognizeTransactionNo: 'No, yo no reconozco el cargo',
            recognizeTransactionYes: 'Sí, reconozco el cargo, pero hay un problema',
            transaction: 'Cuéntenos más sobre esta transacción'
        },
        review: {
            nextPage: 'En la pantalla siguiente tendrá la oportunidad de enviarnos documentación a través de nuestro enlace de Chat en línea.',
            subTitle: 'RESUMEN DE SU SOLICITUD DE DISPUTA',
            title: 'Revisemos los detalles de su disputa.',
            redisputeTitle: 'Revisemos los detalles del motivo por el cual vuelve a disputar.',
            lessTransactions: 'Menos transacciones',
            moreTransactions: 'Más transacciones'
        },
        sandbox: sandbox,
        sorter: sorter,
        technicalError: {
            apologize: 'Nos Disculpamos',
            authFailure: 'En este momento, estamos teniendo dificultades técnicas y no podemos iniciar ni ver disputas.',
            callUs: 'No podemos continuar creando su disputa. Por favor, intente nuevamente más tarde.',
            description: 'Hubo un error técnico.',
            title: 'Lo sentimos.',
            tryAgain: 'Por favor, intente nuevamente más tarde.'
        },
        transactionStatus: transactionStatus,
        transactionDisputeStatusDescription: transactionDisputeStatusDescription,
        transactionDisputeStatusTitle: transactionDisputeStatusTitle,
        uploadDocuments: uploadDocuments
    }
};
export default spanishTranslations;
//# sourceMappingURL=es.js.map